import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom } from '@blaze-runtime/engine-domain';
import { type BlazeSchema } from '@blaze-shared/schema-domain';

import { type DefinitionMapper } from '../../../ai';
import { extractCommonFormFields } from '../../../ai/common/extract-common-form-fields';
import { type CanvasElementDefinition } from '../../../canvas-elements/element-definition';

import { type TextInputDefinition } from './text-input.definition';

export class TextInputDefinitionMapper implements DefinitionMapper<'textInput'> {
  readonly type = 'textInput';

  extract(
    element: CanvasElementFrom<'textInput'>,
    _schemas: Readonly<Record<string, BlazeSchema>>,
    _definition: CanvasElementDefinition<'textInput'>,
  ): PartialDeep<TextInputDefinition> {
    const { input } = element.props.content;

    return {
      ...extractCommonFormFields(element),
      isReadOnly: input?.readonly,
      placeholder: input?.placeholder,
    };
  }
}
